<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <h1 class="titulo-pagina">{{ 'VINCULACIONESTADOFINANCIERO.LBL_VINCULACIONESTADOFINANCIERO' | translate}}</h1>
    </div>
  </div>

  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'VINCULACIONESTADOFINANCIERO.LBL_VINCULACION' | translate }}</label>
          <div *ngIf="!vinEstadoFinancieroSeleccionada">
            <p-dropdown disableTab  id="idVinculacion" name="nomVinculacion" [options]="lisVinculaciones"
                        (onChange)="cambioTipoVinculacion($event.value)"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         formControlName="idTipoVinculacion"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoVinculacion.invalid">
              {{ 'VINCULACIONESTADOFINANCIERO.LBL_VINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
          <label *ngIf="vinEstadoFinancieroSeleccionada"
                 class="falso-combo-texto">{{vinEstadoFinancieroSeleccionada.tipoVinculacion}}</label>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3 pt-5" *ngIf="tipVinculacionSeleccionada && (tipVinculacionSeleccionada.codigo === 'DEUSO' || tipVinculacionSeleccionada.codigo === 'COTITU')">
        <div class="div-form">
          <p-checkbox label="{{ 'VINCULACIONESTADOFINANCIERO.LBL_CONYUGE' | translate}}" binary="true"
                      id="idConyuge"
                      name="nomConyuge"
                      formControlName="indicadorConyuge"></p-checkbox>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3 pt-5" *ngIf="tipVinculacionSeleccionada && (tipVinculacionSeleccionada.codigo === 'DEUSO' || tipVinculacionSeleccionada.codigo === 'COTITU')">
        <div class="div-form">
          <p-checkbox label="{{ 'VINCULACIONESTADOFINANCIERO.LBL_OTRODEUDOR' | translate}}" binary="true"
                      id="idOtroVinculacion"
                      name="nomOtroVinculacion"
                      formControlName="indicadorOtroVinculado"></p-checkbox>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-plus" label="{{(vinEstadoFinancieroSeleccionada ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR') | translate }}"
                type="submit"
                pButton></button>
      </div>
    </div>
  </form>


  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas"
               [value]="lisVinculacionesEstadoFinanciero"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.tipoVinculacion}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorConyuge" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorOtroVinculado" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar && row.codigoTipoVinculacion === 'DEUSO' || row.codigoTipoVinculacion === 'COTITU'"
                        (click)="editar(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton *ngIf="menu.editar && row.codigoTipoVinculacion !== 'TITULAR'"
                        (click)="inhabilitar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
